import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getUsersAdm = async (
  query: string,
  page: number
): Promise<GetUsersOrganizacaoType | { message: string }> => {
  try {
    const result = await apiService.get(`central/usuario`, {
      params: {
        query,
        page: page - 1,
        size: 7,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchNovoUsuario = async (requestDTO: {}): Promise<
  { info: string; id: number } | { message: string }
> => {
  try {
    const result = await apiService.post(`central/usuario`, {
      ...requestDTO,
    })
    if (result.status === 200 || result.status === 201) {
      return { info: 'Usuário criado com sucesso!', id: result.data.id }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchEditarUsuario = async (
  id: number,
  requestDTO: {}
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.put(`central/usuario/${id}`, {
      ...requestDTO,
    })
    if (result.status === 200) {
      return { info: 'Usuário editado com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchAtivaDesativaUsuario = async (
  id: number,
  acao: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.put(`central/usuario/${acao}/${id}`)
    if (result.status === 200) {
      return acao === 'ativar'
        ? { info: 'Usuário ativado!' }
        : { info: 'Usuário desativado!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Cria ou atualiza (upsert) o vínculo do usuário com uma organização (papel + CPF).
export const salvarVinculoOrganizacao = async (
  tenantId: string,
  usuarioId: number,
  vinculoRequestDTO: {}
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      `central/usuario/organizacao/${tenantId}/${usuarioId}`,
      {
        ...vinculoRequestDTO,
      }
    )
    if (result.status === 200 || result.status === 201) {
      return { info: 'Vínculo salvo!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Desativa o vínculo do usuário com uma organização (remoção lógica).
export const desativarVinculoOrganizacao = async (
  tenantId: string,
  usuarioId: number
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.put(
      `central/usuario/organizacao/desativar/${tenantId}/${usuarioId}`
    )
    if (result.status === 200) {
      return { info: 'Vínculo removido!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Lista as organizações às quais o usuário está vinculado.
export const getOrganizacoesUsuario = async (
  usuarioId: number
): Promise<GetUsuarioOrganizacoesType | { message: string }> => {
  try {
    const result = await apiService.get(
      `central/usuario/${usuarioId}/organizacoes`
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Detalhe do vínculo do usuário em uma organização (papel + CPF + ativo).
export const getVinculoOrganizacao = async (
  tenantId: string,
  usuarioId: number
): Promise<GetVinculoOrganizacaoType | { message: string }> => {
  try {
    const result = await apiService.get(
      `central/usuario/organizacao/${tenantId}/${usuarioId}`
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
